import QdtComponents from 'qdt-components';

const options = {
  config: {
    host: 'qap.ipc-global.com',
    appId: '4443f42f-8cf6-4d4a-b834-4cdcd08fa61f',
    secure: true,
    port: 443,
    prefix: ''
  },
  connections: {
    vizApi: true,
    engineApi: true,
  },
};

const qdtComponents = new QdtComponents(options.config, options.connections);

export { qdtComponents, options };

